// extracted by mini-css-extract-plugin
var _1 = "BookingTransferred-hhXfd";
var _2 = "Checkmark-N8Wsy";
var _3 = "Link-CGAmY";
var _4 = "Paragraph-JwRq0";
var _5 = "SuccessIcon-b_S4d";
var _6 = "Title-E98MQ";
var _7 = "fadeIn-aSlqs";
var _8 = "popIn-uarO6";
export { _1 as "BookingTransferred", _2 as "Checkmark", _3 as "Link", _4 as "Paragraph", _5 as "SuccessIcon", _6 as "Title", _7 as "fadeIn", _8 as "popIn" }
